(function (theme) {
  let itemToAdd = {};

  const url = new URL(window.location);
  const product = theme.product;
  const productOptions = product.options;
  const allVariants = product.variants;
  let possibleVariants = allVariants;
  let selections = product.selected_variant ? product.selected_variant.title.split(' - ') : [];

  const qtyChangeEvent = new Event('change');

  const variantSelectorWrapper = document.querySelector('.js-variant-selector');
  const variantSelect = document.querySelector('.product__form-variant-ids');
  const addButton = document.getElementById('new-variant-selector-add');
  const qtyInput = document.querySelector('.js-quantity-input');
  const qtyIncr = document.querySelector('.js-quantity-plus');
  const qtyDecr = document.querySelector('.js-quantity-minus');
  const sku = document.getElementById('js-variant-sku');
  const stock = document.getElementById('js-stock-availability');

  variantSelectorWrapper.innerHTML = generateOptionsMarkup(productOptions);

  attachInputChangeEvent(variantSelectorWrapper);

  itemToAdd.quantity = parseInt(qtyInput.value, 10);

  if (product.selected_variant) {
    updatePossibleVariants(selections, variantSelectorWrapper);
  }

  qtyInput.addEventListener('change', () => {
    itemToAdd.quantity = parseInt(qtyInput.value, 10);
  });

  qtyIncr.addEventListener('click', () => {
    qtyInput.value = parseInt(qtyInput.value, 10) + 1;
    qtyInput.dispatchEvent(qtyChangeEvent);
  });

  qtyDecr.addEventListener('click', () => {
    qtyInput.value = parseInt(qtyInput.value, 10) - 1;
    qtyInput.dispatchEvent(qtyChangeEvent);
  });

  addButton.addEventListener('click', (e) => {
    e.preventDefault();
    document.querySelector('body').classList.add('loader-active');
    try{
      let selling_plan = document.querySelector('input[name="selling_plan"]').value;
      if (selling_plan !=''){
        itemToAdd.selling_plan = selling_plan;  
      }
    }catch(e){
      console.log(e)
    }

    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(itemToAdd)
    }).then(() => {
      fetch('/cart.js').then(() => {
        $.get(window.location.href, (data) => {
          let parser = new DOMParser();
          let doc;

          if (data.body) {
            doc = parser.parseFromString(data.body, 'text/html');
          } else {// if response is html format
            doc = parser.parseFromString(data, 'text/html');
          }

          document.querySelector('body cart-drawer').innerHTML = doc.querySelector('body cart-drawer').innerHTML;
          document.querySelector("#cart-icon-bubble").innerHTML = doc.querySelector('#cart-icon-bubble').innerHTML;
          document.querySelector('body cart-drawer').classList.remove('is-empty');

          document.querySelector('.drawer').open();
          document.querySelector('body').classList.remove('loader-active');

          document.dispatchEvent(new Event('productAdded'));
        });
      });
    });
  });

  function generateOptionsMarkup(options) {
    let productOptionsMarkup = '';

    options.forEach((option, optionIndex) => {
      // Sort the options before building the markup
      option.values.sort((a, b) => a - b);

      const inputs = option.values.map((value) => {
        return `
          <div class="product__form-option">
            <input
              type="radio"
              id="variant--${handleize(value)}"
              name="option[${option.name}]"
              class="product__form-option-input"
              value="${value.replace(/"/g, '&quot')}"
              data-option-index="${optionIndex}"
              ${selections[optionIndex] === value ? `checked` : ``}
            />
            <label
              for="variant--${handleize(value)}"
              class="product__form-option-label"
            >
              ${value}
            </label>
          </div>
        `;
      }).join('');
  
      productOptionsMarkup += `
        <div class="product__form-field">
          <p class="product__form-name">${option.name}</p>
          <div class="product__form-options">
            ${inputs}
          </div>
        </div>
      `;
    });

    return productOptionsMarkup;
  }

  function attachInputChangeEvent(parentDiv) {
    parentDiv.querySelectorAll('.product__form-option-input').forEach((input) => {
      input.addEventListener('change', () => {
        selections = [];
        parentDiv.querySelectorAll('.product__form-option-input:checked').forEach((input) => {
          const index = input.dataset.optionIndex;
          selections[index] = input.value;
        });

        updatePossibleVariants(selections, parentDiv);
      });
    });
  }

  function updatePossibleVariants(selections, parentDiv) {
    possibleVariants = productOptions.map((option, optionIndex) => {
      const optionKey = `option${optionIndex + 1}`;
      let newSelections = selections;
      if (selections[optionIndex]) {
        newSelections = newSelections.slice(0, optionIndex);
      }

      const possibleVariants = allVariants.filter((variant) => newSelections.every(
        (selection, index) => selection === null || variant[`option${index+1}`] === selection,
      ));
      
      return possibleVariants.reduce((options, variant) => {
        const { [variant[optionKey]]: optionVariants = [] } = options;
        optionVariants.push(variant);
        return { ...options, [variant[optionKey]]: optionVariants };
      }, {});
    });

    checkSelections(selections);
    disableImpossibleOptions(possibleVariants, parentDiv);
  }

  function checkSelections(selections) {
    let possibleVariants = allVariants;

    selections.forEach((selection, index) => {
      const filteredVariants = possibleVariants.filter(
        (variant) => variant[`option${index + 1}`] === selection,
      );

      if (!filteredVariants.length) {
        selections[index] = null;
        return;
      }

      possibleVariants = filteredVariants;
    });

    const variantTitle = selections.join(' - ');
    const selectedVariant = possibleVariants.find(({ title }) => title === variantTitle);

    sku.textContent = selectedVariant ? `SKU: ${selectedVariant.sku}` : `SKU:`;
    stock.textContent = selectedVariant ? `${selectedVariant.inventory_quantity} available` : ``;

    if (selectedVariant) {
      url.searchParams.set('variant', selectedVariant.id);

      setTimeout(function() {
        jQuery.get(url, function(data){
          const parser = new DOMParser();
          //Convert response from string to HTML object
          let doc;

          if (data.body) {// if response is json format
            doc = parser.parseFromString(data.body, 'text/html');
          } else {// if response is html format
            doc = parser.parseFromString(data, 'text/html');
          }

          // Update tier prices
          if (document.querySelector('body div[id*="price-template"]')) {
            document.querySelector('body div[id*="price-template"]').innerHTML = doc.querySelector('body div[id*="price-template"]').innerHTML;
          }

          if (document.querySelector('body .product-pricing-tiers-section')) {
            document.querySelector('body .product-pricing-tiers-section').replaceWith(doc.querySelector('body .product-pricing-tiers-section'));
          }

          if (document.querySelector('.product-form .line-item-property__field')) {
            document.querySelector('.product-form .line-item-property__field').replaceWith(doc.querySelector('.product-form .line-item-property__field'));
          }
          
        });

        const mediaGalleries = document.querySelectorAll(`[id^="MediaGallery`)[0];
        const idmediaGalleries = mediaGalleries.getAttribute("id").split('MediaGallery-')[1]
        mediaGalleries.setActiveMedia(`${idmediaGalleries}-${selectedVariant.featured_media.id}`, true)

        variantSelect.value = selectedVariant.id;
        itemToAdd.id = variantSelect.value;
        addButton.disabled = !selectedVariant.available;
        window.history.replaceState({ product: product }, '', url.toString());
        
      }, 100);

    } else {
      url.searchParams.delete('variant');
      addButton.disabled = true;
    }

    //window.history.replaceState({ product: product }, '', url.toString());
  }

  function disableImpossibleOptions(possibleVariants, container) {
    const optionFields = container.querySelectorAll('.product__form-field');

    optionFields.forEach((field, index) => {
      const inputs = field.querySelectorAll('.product__form-option-input');
      
      inputs.forEach((input) => {
        input.disabled = !Object.keys(possibleVariants[index]).includes(input.value);
        input.classList.toggle('product__form-option-input--impossible', !Object.keys(possibleVariants[index]).includes(input.value));
      });
    })
  }

  function noAccents(content, remove = false, replacement = '') {
    const ALL_COMBINING_DIACRITICS = /[\u0300-\u036f\u1ab0-\u1aff\u1dc0-\u1dff\u20d0-\u20ff\ufe20-\ufe2f]+/g;

    let withoutAccents = String(content).normalize('NFKD').replace(ALL_COMBINING_DIACRITICS, '');
    if (remove) {
      // x00-x7E is the ASCII character range
      withoutAccents = withoutAccents.replace(/[^\u0020-\u007E]/g, replacement);
    }
    return withoutAccents;
  }

  function handleize(content, separator = '-', replacement = '') {
    let output = String(content);
    // handles should be lowercase
    output = output.toLowerCase();
    // strip combining diacritics such as accents
    output = noAccents(output, true, replacement);
    // handles should begin and end with an alphanumeric
    output = output.replace(/^[^a-z0-9_]+|[^a-z0-9_]+$/g, replacement);
    // replace runs of non-alphanumerics with the separator
    output = output.replace(/[^a-z0-9_]+/g, separator);
    return output;
  }
})(window.theme = window.theme || {});

